<template>
  <form name="company" class="needs-validation" novalidate>
    <div
      id="alert"
      class="alert alert-dismissible fade show m-alert m-alert--outline mb-4 mt-4"
      :class="alert.color"
      role="alert"
      v-if="alert.message"
    >
      <button type="button" class="close" aria-label="Close" @click="alert.message = ''"></button>
      <i :class="alert.icon"></i> &nbsp;
      <strong>{{ alert.message }}</strong>
      <br />
      {{ alert.reason }}
    </div>
    <div class="alert m-alert m-alert--default mb-3 mt-4" role="alert">
      <h5><i class="fas fa-info-circle"></i> Informações gerais</h5>
    </div>
    <div class="row mb-4">
      <div class="col-md-2" v-if="data.id">
        <label>ID Perfil</label>
        <div class="input-group">
          <input
            type="text"
            class="form-control"
            placeholder
            v-model="data.id"
            readonly="readonly"
          />
        </div>
      </div>
      <div :class="{ 'col-md-5': data.id, 'col-md-7': !data.id }">
        <div class="form-group" :class="{ 'has-danger': !data.name }">
          <label for="name">
            Perfil
            <span class="m--font-danger">*</span>
          </label>
          <div class="input-group">
            <input
              id="name"
              type="text"
              ref="name"
              class="form-control m-input"
              placeholder
              v-model="data.name"
              required
            />
          </div>
        </div>
      </div>
      <div class="col-md-5">
        <div class="form-group" :class="{ 'has-danger': !data.desc }">
          <label for="desc">
            Descrição
            <span class="m--font-danger">*</span>
          </label>
          <div class="input-group">
            <input
              type="text"
              class="form-control m-input"
              name="desc"
              id="desc"
              placeholder
              v-model="data.desc"
              required
            />
          </div>
        </div>
      </div>
    </div>

    <hr class="row mt-5 mb-3" />
    <div class="row">
      <div class="col-md-12 text-right">
        <p class="p-0 m-0">
          <a
            href="#"
            @click.prevent="$refs.name.focus()"
            target="_self"
            class="m--font-danger"
            v-if="!data.name"
          >
            O campo
            <strong>Perfil</strong> é obrigatório *
          </a>
        </p>
        <p class="p-0 m-0">
          <a
            href="#"
            @click.prevent="$refs.desc.focus()"
            target="_self"
            class="m--font-danger"
            v-if="!data.desc"
          >
            O campo
            <strong>Descrição</strong> é obrigatório *
          </a>
        </p>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <div class="alert m-alert m-alert--default mb-3 mt-4" role="alert">
          <h5><i class="fas fa-info-circle"></i> Selecione abaixo os acessos desse perfil:</h5>
        </div>
        <div class="m-portlet m-portlet--tab">
          <div class="m-portlet__body">
            <div>
              <span class="loading-request" v-show="loading"></span>
              <div class="page-amounts">
                <nav aria-label="...">
                  <ul class="pagination pagination-md">
                    <li class="page-item" :class="{ selected: amount == 10 }">
                      <a @click="amount = 10" class="page-link paginate">10</a>
                    </li>
                    <li class="page-item" :class="{ selected: amount == 25 }">
                      <a @click="amount = 25" class="page-link paginate">25</a>
                    </li>
                    <li class="page-item" :class="{ selected: amount == 50 }">
                      <a @click="amount = 50" class="page-link paginate">50</a>
                    </li>
                    <li class="page-item" :class="{ selected: amount == 100 }">
                      <a @click="amount = 100" class="page-link paginate">100</a>
                    </li>
                  </ul>
                </nav>
              </div>
              <div class="paginator-info-top m-2">
                <span class="m--font-gray" v-if="scopes.from"
                  >Exibindo itens de {{ scopes.from }} a {{ scopes.to }}, de um total de
                  {{ scopes.total }}.</span
                >
                <span class="m--font-gray" v-else>Nenhum item a ser exibido.</span>
              </div>
            </div>
            <div class="table-responsive">
              <div class="container-table">
                <table class="table table-striped- table-bordered table-hover table-checkable">
                  <thead>
                    <tr>
                      <td class="text-center align-middle" width="20">
                        <label
                          class="m-checkbox m-checkbox--single m-checkbox--solid m-checkbox--brand mb-0 mt-0"
                          v-b-tooltip.hover
                          title="Selecionar todos escopos desta página"
                        >
                          <input
                            type="checkbox"
                            @click="selectAllReport"
                            v-model="allSelected"
                            class="m-group-checkable"
                          />
                          <span></span>
                        </label>
                      </td>
                      <td
                        nowrap
                        class="text-center align-middle pointer"
                        width="60"
                        :class="{ 'table-sorted': sortType == 'id' }"
                        @click="sortCall('id')"
                      >
                        ID Perfil
                        <span
                          class="fas fa-caret-down sorted"
                          v-if="sortType == 'id' && !sortReverse"
                        ></span>
                        <span
                          class="fas fa-caret-up sorted"
                          v-if="sortType == 'id' && sortReverse"
                        ></span>
                        <span class="fal fa-sort sort" v-if="sortType != 'id'"></span>
                      </td>
                      <td
                        nowrap
                        class="text-center align-middle pointer"
                        width="200"
                        :class="{ 'table-sorted': sortType == 'desc' }"
                        @click="sortCall('desc')"
                      >
                        Detalhe
                        <span
                          class="fas fa-caret-down sorted"
                          v-if="sortType == 'desc' && !sortReverse"
                        ></span>
                        <span
                          class="fas fa-caret-up sorted"
                          v-if="sortType == 'desc' && sortReverse"
                        ></span>
                        <span class="fal fa-sort sort" v-if="sortType != 'desc'"></span>
                      </td>
                      <td
                        nowrap
                        class="text-center align-middle pointer"
                        width="200"
                        :class="{ 'table-sorted': sortType == 'name' }"
                        @click="sortCall('name')"
                      >
                        HASH
                        <span
                          class="fas fa-caret-down sorted"
                          v-if="sortType == 'name' && !sortReverse"
                        ></span>
                        <span
                          class="fas fa-caret-up sorted"
                          v-if="sortType == 'name' && sortReverse"
                        ></span>
                        <span class="fal fa-sort sort" v-if="sortType != 'name'"></span>
                      </td>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td></td>
                      <td>
                        <input
                          type="text"
                          class="form-control form-control-sm m-input"
                          @input="callDataScope"
                          v-model="filters.id"
                        />
                      </td>
                      <td>
                        <input
                          type="text"
                          class="form-control form-control-sm m-input"
                          @input="callDataScope"
                          v-model="filters.desc"
                        />
                      </td>
                      <td>
                        <input
                          type="text"
                          class="form-control form-control-sm m-input"
                          @input="callDataScope"
                          v-model="filters.name"
                        />
                      </td>
                    </tr>
                    <tr v-for="(scope, id) in scopes.data" :key="id">
                      <td class="text-center align-middle" width="60">
                        <label
                          class="m-checkbox m-checkbox--single m-checkbox--solid m-checkbox--brand mb-0 mt-0"
                          v-b-tooltip.hover.right.title="`#${scope.id} - Selecionar esse escopo`"
                        >
                          <input
                            type="checkbox"
                            v-model="roleIds"
                            @click="select"
                            :value="scope.id"
                            class="m-group-checkable"
                          />
                          <span></span>
                        </label>
                      </td>
                      <td class="text-center align-middle">{{ scope.id }}</td>
                      <td class="text-left align-middle">{{ scope.desc }}</td>
                      <td class="text-center align-middle">{{ scope.name }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div>
              <div class="paginator-info-bottom mt-2">
                <span class="m--font-gray" v-if="scopes.from"
                  >Exibindo itens de {{ scopes.from }} a {{ scopes.to }}, de um total de
                  {{ scopes.total }}.</span
                >
                <span class="m--font-gray" v-else>Nenhum item a ser exibido.</span>
              </div>
              <div class="paginator-list">
                <nav aria-label="...">
                  <ul class="pagination pagination-md">
                    <li class="page-item" :class="{ disabled: scopes.current_page == 1 }">
                      <a class="page-link paginate" @click="page = 1"
                        ><i class="fal fa-angle-double-left"></i
                      ></a>
                    </li>
                    <li class="page-item" :class="{ disabled: scopes.current_page == 1 }">
                      <a class="page-link paginate" @click="page = scopes.current_page - 1"
                        ><i class="fal fa-angle-left"></i
                      ></a>
                    </li>
                    <li
                      class="page-item"
                      :class="{ disabled: scopes.current_page == 1 }"
                      v-if="scopes.current_page > 2"
                    >
                      <a class="page-link paginate" @click="page = scopes.current_page - 2">
                        {{ scopes.current_page - 2 }}</a
                      >
                    </li>
                    <li
                      class="page-item"
                      :class="{ disabled: scopes.current_page == 1 }"
                      v-if="scopes.current_page > 1"
                    >
                      <a class="page-link paginate" @click="page = scopes.current_page - 1">
                        {{ scopes.current_page - 1 }}</a
                      >
                    </li>
                    <li class="page-item selected">
                      <a class="page-link paginate"> {{ scopes.current_page }} </a>
                    </li>
                    <li
                      class="page-item"
                      :class="{ disabled: scopes.current_page == scopes.last_page }"
                      v-if="scopes.current_page < scopes.last_page"
                    >
                      <a class="page-link paginate" @click="page = scopes.current_page + 1">
                        {{ scopes.current_page + 1 }}
                      </a>
                    </li>
                    <li
                      class="page-item"
                      :class="{ disabled: scopes.current_page + 1 == scopes.last_page }"
                      v-if="scopes.current_page + 1 < scopes.last_page"
                    >
                      <a class="page-link paginate" @click="page = scopes.current_page + 2">
                        {{ scopes.current_page + 2 }}
                      </a>
                    </li>
                    <li
                      class="page-item"
                      :class="{ disabled: scopes.current_page == scopes.last_page }"
                    >
                      <a class="page-link paginate" @click="page = scopes.current_page + 1"
                        ><i class="fal fa-angle-right"></i
                      ></a>
                    </li>
                    <li
                      class="page-item"
                      :class="{ disabled: scopes.current_page == scopes.last_page }"
                    >
                      <a class="page-link paginate" @click="page = scopes.last_page"
                        ><i class="fal fa-angle-double-right"></i
                      ></a>
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
            <div class="pt-4"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="row mb-5">
      <div class="col-md-12 text-right">
        <button
          @click.prevent="saveForm()"
          class="btn"
          :class="{ 'btn-metal': !formIsValid, 'btn-focus': formIsValid }"
          :disabled="!formIsValid"
        >
          <i class="fas fa-save" v-if="formIsValid"></i>
          <i class="fas fa-exclamation-triangle" v-else></i>
          Salvar
        </button>
      </div>
    </div>
  </form>
</template>

<script>
import { returnMessageFormMixin } from '@/mixins/returnMessageFormMixin.js';

import { baseApiUrl } from '@/global';
import axios from 'axios';

export default {
  mixins: [returnMessageFormMixin],
  name: 'RoleSaveForm',
  data() {
    return {
      doctype: 0,
      data: {
        contract_type: 0,
        audit: {
          field: [],
          user: false,
        },
      },
      scopes: {},
      alert: {
        color: 'alert-primary',
        icon: 'fas fa-spinner fa-spin fa-lg',
        message: '',
        reason: '',
      },
      sortType: localStorage.scopesSortType ? localStorage.scopesSortType : 'id',
      sortReverse: localStorage.scopesSortReverse
        ? JSON.parse(localStorage.scopesSortReverse)
        : false,
      amount: localStorage.scopesDataAmount ? localStorage.scopesDataAmount : 10,
      page: localStorage.scopesDataPage ? localStorage.scopesDataPage : 1,
      filters: {
        id: localStorage.scopesFilterId ? localStorage.scopesFilterId : '',
        name: localStorage.scopesFilterName ? localStorage.scopesFilterName : '',
        desc: localStorage.scopesFilterDesc ? localStorage.scopesFilterDesc : '',
      },
      roleIds: [],
      allSelected: false,
    };
  },
  methods: {
    saveForm() {
      this.messageWaitingSave();
      this.$refs.name.focus();

      const { data } = this;

      const url = `${baseApiUrl}/v1/role/save`;
      axios
        .post(url, { role: data, scopes: this.roleIds })
        .then((res) => {
          this.logMessageForm(res);
          this.data = data;
        })
        .catch((error) => this.logMessageFormFailed(error.response));
    },
    getDatas() {
      const url = `${baseApiUrl}/v1/role/data/${this.roleId}`;
      axios(url).then((res) => {
        this.data = res.data;
        this.selectUserScopes();
      });
    },
    getScopes() {
      const url = `${baseApiUrl}/v1/scope/search/${this.convertFilters()}`;
      axios(url).then((res) => {
        this.scopes = res.data;
        if (res.data.current_page > res.data.last_page) {
          this.page = 1;
        }
      });
    },
    selectUserScopes() {
      this.roleIds = [];
      const { scopes: userScope } = this.data;
      userScope.forEach((scope) => {
        this.roleIds.push(scope.id);
      });
    },
    callData() {
      this.getDatas();
    },
    setFilter(filterToChange, id) {
      this.filters[filterToChange] = id;
      this.getScopes();
    },
    clearFilters() {
      this.filters.id = '';
      this.filters.name = '';
      this.filters.desc = '';
      this.filters.sortType = 'name';
      this.filters.sortReverse = false;
      this.getScopes();
    },
    setStorageFilters() {
      localStorage.setItem('scopesFilterId', this.filters.id);
      localStorage.setItem('scopesFilterName', this.filters.name);
      localStorage.setItem('scopesFilterDesc', this.filters.desc);
      localStorage.setItem('scopesDataAmount', this.amount);
      localStorage.setItem('scopesDataPage', this.page);
      localStorage.setItem('scopesSortType', this.sortType);
      localStorage.setItem('scopesSortReverse', this.sortReverse);
    },
    convertFilters() {
      const filters = `?page=${this.page ? this.page : 1}&id=${
        this.filters.id ? this.filters.id : ''
      }&name=${this.filters.name ? this.filters.name : ''}&desc=${
        this.filters.desc ? this.filters.desc : ''
      }&amount=${this.amount}&sortType=${this.sortType}&sortOrder=${
        this.sortReverse ? 'DESC' : 'ASC'
      }`;
      return filters;
    },
    sortCall(sortType) {
      this.sortReverse = this.sortType == sortType ? !this.sortReverse : false;
      this.sortType = sortType;
    },
    callDataScope() {
      const timeWindow = 700;
      clearTimeout(this.timeoutId);
      this.timeoutId = setTimeout(() => {
        this.scopes.current_page = null;
        this.setStorageFilters();
        this.getScopes();
      }, timeWindow);
    },
    selectAllReport() {
      this.roleIds = [];
      this.allSelected = !this.allSelected;
      if (this.allSelected) {
        const { data: scopes } = this.scopes;
        scopes.forEach((scope) => {
          this.roleIds.push(scope.id);
        });
      }
    },
    select() {
      this.allSelected = false;
    },
  },
  watch: {
    amount() {
      if (this.page == 1) {
        this.callDataScope();
      } else {
        this.page = 1;
      }
    },
    page() {
      this.callDataScope();
    },
    sortType() {
      this.callDataScope();
    },
    sortReverse() {
      this.callDataScope();
    },
  },
  computed: {
    roleId() {
      return this.$store.state.showRoleSave;
    },
    formIsValid() {
      if (this.data.name && this.data.desc && this.roleIds.length > 0) {
        return true;
      }
      return false;
    },
    loading() {
      return !this.scopes.current_page;
    },
  },
  beforeMount() {
    if (this.roleId && this.roleId !== 'add') {
      this.callData();
    }
    this.getScopes();
  },
};
</script>

<style></style>
